import { render, staticRenderFns } from "./DashboardExplore.vue?vue&type=template&id=3af8eb48&scoped=true&"
var script = {}
import style0 from "./DashboardExplore.vue?vue&type=style&index=0&id=3af8eb48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af8eb48",
  null
  
)

export default component.exports